module.exports = __webpack_public_path__ + "img/album21_35.d24fc6e6.jpg";